export const abbreviateNumber = (num: number) => {
	const suffixes = ['', 'K', 'M', 'B', 'T'];
	const absNum = Math.abs(num);

	if (absNum < 1) {
		return num.toString();
	}

	const tier = Math.floor(Math.log10(absNum) / 3);
	const scale = Math.pow(10, tier * 3);
	const scaled = num / scale;

	const roundedNum = Math.round(scaled * 10) / 10;
	return roundedNum + suffixes[tier];
};
